export const reCalculateDeliveryFee = (costDeliver, totalItems) => {
  return Math.round(costDeliver / totalItems / 108) * totalItems * 108;
}